import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import classnames from 'classnames'
import ReactCodeInput from 'react-code-input'
import { browserHistory } from 'react-router'

import { confirmEmail, resendConfirmEmail, CONFIRM_EMAIL } from '_modules/user/actions'
import { createFieldMissingErrorMessage, deepCopyJSON } from '_utils/helperFunction'

import styles from './styles.css'

const mapStateToProps = ({ settings, user, loading, error }) => ({
  settings,
  user,
  isLoadingConfirmEmail: !!loading.get(CONFIRM_EMAIL.ACTION),
  confirmEmailErrors: error.get(CONFIRM_EMAIL.ACTION),
})

const mapDispatchToProps = {
  confirmEmail,
  resendConfirmEmail,
}

class ConfirmEmail extends Component {
  static propTypes = {
    user: ImmutableProptypes.map,
    confirmEmail: PropTypes.func.isRequired,
    resendConfirmEmail: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
  }

  state = {
    code: '',
    sent: '',
  }

  componentWillMount() {
    if (this.props.location.query.token) {
      const paramToken = this.props.location.query.token.toUpperCase()
      const payload = {
        confirmEmailToken: paramToken,
      }
      this.props.confirmEmail(payload)
    }
  }

  componentWillReceiveProps({ isLoadingConfirmEmail, confirmEmailErrors, user }) {
    if (this.props.isLoadingConfirmEmail && !isLoadingConfirmEmail) {
      if (user.get('emailConfirmed', false)) {
        browserHistory.push('/')
      } else {
        this.props.displayError('Incorrect Code')
      }
    }
  }

  onChange = value => {
    this.setState({
      code: value.toUpperCase(),
    })
  }

  onSubmit = event => {
    event.preventDefault()
    const { code } = this.state
    this.props.clearError()

    if (!code || code.length !== 6) {
      this.props.displayError('Invalid Code')
    } else {
      const payload = { confirmEmailToken: code }

      this.props.confirmEmail(payload)
    }
  }

  onResend = e => {
    e.preventDefault()

    this.props.displayError('Confirmation Email Resent', {
      backgroundColor: 'rgba(30,145,214,0.85)',
    })
    this.props.resendConfirmEmail()
  }

  handleKeyDown = e => {
    if (e.keyCode === 13) e.preventDefault()
  }

  onKeyPress = event => {
    event.preventDefault()
  }

  formRef = null

  render() {
    const { code, sent } = this.state
    const { user } = this.props
    return (
      <div>
        <form
          ref={form => (this.formRef = form)}
          onKeyDown={this.handleKeyDown}
          onSubmit={this.onKeyPress}
          className={classnames(styles.main, styles.Grid)}
        >
          <div
            className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['page-name'])}
          >
            Enter Verification Code
          </div>
          <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['info'])}>
            Verification code was sent to {user.get('email', '')}
          </div>
          <div style={{ margin: 20 }} />
          <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
            <ReactCodeInput
              fields={6}
              value={code}
              onChange={this.onChange}
              forceUppercase
              onKeyDown={this.handleKeyDown}
              inputStyle={{
                MozAppearance: 'textfield',
                borderRadius: '6px',
                border: '1px solid',
                boxShadow: '0px 0px 10px 0px rgba(0,0,0,.10)',
                margin: '4px',
                paddingLeft: '8px',
                width: '45px',
                height: '50px',
                fontSize: '30px',
                boxSizing: 'border-box',
                color: 'black',
                background: 'white',
              }}
            />
          </div>
          <div style={{ margin: 20 }} />
          {sent && (
            <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.msg)}>
              {sent}
            </div>
          )}
          <div style={{ margin: 5 }} />
          <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
            <button type="submit" onClick={this.onResend} className={classnames(styles.button)}>
              RESEND EMAIL
            </button>
            <button type="submit" onClick={this.onSubmit} className={classnames(styles.button)}>
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmEmail)



// WEBPACK FOOTER //
// ./src/views/confirm-email/index.js